import React, { useRef, useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { DOC_LABELS, DOC_ACCEPT, checkDocFile, defaultLabelFor } from './poDocumentRules';

// Label picker + multi-file chooser. Calls onFiles(validFiles, label); invalid files are explained via toast.
export const PODocumentPicker = ({ source = 'detail', busy, onFiles, testPrefix = 'po-docs' }) => {
  const inputRef = useRef(null);
  const [label, setLabel] = useState(defaultLabelFor(source));

  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    const ok = [];
    files.forEach((f) => {
      const problem = checkDocFile(f);
      if (problem) toast.error(problem, { duration: 9000 });
      else ok.push(f);
    });
    if (ok.length) onFiles(ok, label);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testPrefix}-picker`}>
      <Select value={label} onValueChange={setLabel}>
        <SelectTrigger className="h-9 w-[150px]" data-testid={`${testPrefix}-label-select`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {DOC_LABELS.map((l) => (
            <SelectItem key={l.value} value={l.value} data-testid={`${testPrefix}-label-${l.value}`}>{l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" size="sm" className="h-9" disabled={busy}
        onClick={() => inputRef.current?.click()} data-testid={`${testPrefix}-add-btn`}>
        {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Upload className="mr-1.5 h-4 w-4" />}
        Add files
      </Button>
      <input ref={inputRef} type="file" multiple accept={DOC_ACCEPT} className="hidden"
        onChange={handleChange} data-testid={`${testPrefix}-file-input`} />
      <span className="text-xs text-muted-foreground">PDF, JPG or PNG, up to 25 MB each</span>
    </div>
  );
};
